import React from "react";

const ButtonCard = ({ text, value, className, module = "" }) => {
  return (
    <div
      style={{
        boxShadow: "0 0 20px rgba(255,255,255,0.4) inset",
      }}
      className={`${className} ${
        module === "crypto-hunt"
          ? "2xl:px-12 sm:px-8 xs:px-6 px-4  2xl:py-3 xs:py-2 py-1"
          : "px-6 2xl:py-2 py-1"
      } flex items-center  gap-x-2 bg-black rounded-full border-2 border-primary`}
    >
      <h1
        className={` font-redHat uppercase ${
          module === "crypto-hunt"
            ? "2xl:text-xl xl:text-base sm:text-[14px] xs:text-xs text-[10px] text-center text-[#ddd]"
            : "sm:text-xl text-[14px]"
        } `}
      >
        {text}
      </h1>
      <span
        className={`text-[#200052] font-bold   ${(module = "crypto-hunt"
          ? "xl:text-xl sm:text-base xs:text-xs text-[10px]"
          : "xl:text-xl text-base")} `}
      >
        {value}
      </span>
    </div>
  );
};

export default ButtonCard;
